var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("check-box-list-row", {
        attrs: {
          title: "Expanded.BasicInfo.PlaceOpen.HiredPerson.Title",
          options: _vm.hiredPersonOptions,
          required: true
        },
        model: {
          value: _vm.placeOpen.hiredPerson,
          callback: function($$v) {
            _vm.$set(_vm.placeOpen, "hiredPerson", $$v)
          },
          expression: "placeOpen.hiredPerson"
        }
      }),
      _vm._v(" "),
      _vm.showDescriptionForPartialDisabled
        ? _c("text-area-row", {
            attrs: {
              title:
                "Expanded.BasicInfo.PlaceOpen.HowPartialDisabilityIsNoticed",
              id: "howpartialdisabilityisnoticed",
              required: true,
              maxLength: 1000,
              rows: 10
            },
            model: {
              value: _vm.placeOpen.howPartialDisabilityIsNoticed,
              callback: function($$v) {
                _vm.$set(_vm.placeOpen, "howPartialDisabilityIsNoticed", $$v)
              },
              expression: "placeOpen.howPartialDisabilityIsNoticed"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("radio-button-row", {
        key: _vm.radioButtonValueChanged,
        attrs: {
          title: "Expanded.BasicInfo.PlaceOpen.IsApprenticeships",
          required: true
        },
        model: {
          value: _vm.placeOpen.isApprenticeships,
          callback: function($$v) {
            _vm.$set(_vm.placeOpen, "isApprenticeships", $$v)
          },
          expression: "placeOpen.isApprenticeships"
        }
      }),
      _vm._v(" "),
      _vm.showApprenticeshipsDescription
        ? _c("text-area-row", {
            attrs: {
              title: "Expanded.BasicInfo.PlaceOpen.ApprenticeshipsDescription",
              id: "apprenticeshipdescription",
              required: true,
              maxLength: 300,
              rows: 5
            },
            model: {
              value: _vm.placeOpen.apprenticeshipsDescription,
              callback: function($$v) {
                _vm.$set(_vm.placeOpen, "apprenticeshipsDescription", $$v)
              },
              expression: "placeOpen.apprenticeshipsDescription"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("date-input-row", {
        attrs: {
          title: "Expanded.BasicInfo.PlaceOpen.StartTime",
          name: "Expanded.BasicInfo.PlaceOpen.StartTime",
          instructionsKey:
            "Expanded.BasicInfo.PlaceOpen.StartTime_Instructions",
          placeholder: _vm.$t("DatePicker.FormatPlaceholder"),
          required: true,
          rules: _vm.startTimeRules
        },
        model: {
          value: _vm.basicInfo.startTime,
          callback: function($$v) {
            _vm.$set(_vm.basicInfo, "startTime", $$v)
          },
          expression: "basicInfo.startTime"
        }
      }),
      _vm._v(" "),
      _c("date-input-row", {
        attrs: {
          title: "Expanded.BasicInfo.PlaceOpen.EndTime",
          name: "Expanded.BasicInfo.PlaceOpen.EndTime",
          instructionsKey: "Expanded.BasicInfo.PlaceOpen.EndTime_Instructions",
          placeholder: _vm.$t("DatePicker.FormatPlaceholder"),
          required: true,
          rules: _vm.endTimeRules
        },
        model: {
          value: _vm.basicInfo.endTime,
          callback: function($$v) {
            _vm.$set(_vm.basicInfo, "endTime", $$v)
          },
          expression: "basicInfo.endTime"
        }
      }),
      _vm._v(" "),
      _c("single-select-accessible", {
        attrs: {
          title: "Expanded.BasicInfo.PlaceOpen.Location",
          options: _vm.municipalities,
          required: true,
          dropdownId: "placeopenlocation",
          doNotUseResources: true,
          optionOutput: true,
          value:
            _vm.placeOpen.location.length > 0
              ? _vm.placeOpen.location[0]
              : { name: null, id: null }
        },
        on: {
          input: function($event) {
            _vm.placeOpen.location = $event.name
              ? [{ name: $event.name, id: $event.id }]
              : []
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }